import { variant, fields } from 'variant';
import type { VariantOf, TypeNames } from 'variant';

export const SiteValue = variant({
  NotConfigured: {},
  Resolved: fields<{ siteId: string }>(),
});

export type SiteValue<T extends TypeNames<typeof SiteValue> = undefined> =
  VariantOf<typeof SiteValue, T>;
